import {
  CheckDepositTransactionTypeCode,
  CheckImage,
  CheckImageType,
  CheckWithdrawalTransactionTypeCode,
  DetailedTransaction,
  TransactionStatus,
  TransactionTypeCode,
} from '../data';

export function isCheckDeposit(transaction: DetailedTransaction): boolean {
  return transaction.type.code in CheckDepositTransactionTypeCode;
}

function isCheckWithdrawal(transaction: DetailedTransaction): boolean {
  return transaction.type.code in CheckWithdrawalTransactionTypeCode;
}

export function isCheckTransaction(transaction: DetailedTransaction): boolean {
  return isCheckDeposit(transaction) || isCheckWithdrawal(transaction);
}

export function showEstimatedAvailability(transaction: DetailedTransaction): boolean {
  return (
    transaction.status === TransactionStatus.Pending &&
    (transaction.type.code === TransactionTypeCode.CPDEP ||
      transaction.type.code === TransactionTypeCode.CPWTH ||
      isCheckDeposit(transaction))
  );
}

export function getCheckImages(transaction: DetailedTransaction): {
  front: CheckImage | undefined;
  back: CheckImage | undefined;
} {
  return {
    front: transaction.check?.images.find(
      value =>
        value.type ===
        (transaction.type.code === CheckDepositTransactionTypeCode.CHKDRT
          ? CheckImageType.ReturnCheckFront
          : CheckImageType.CheckFront)
    ),
    back: transaction.check?.images.find(
      value =>
        value.type ===
        (transaction.type.code === CheckDepositTransactionTypeCode.CHKDRT
          ? CheckImageType.ReturnCheckBack
          : CheckImageType.CheckBack)
    ),
  };
}
